import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  margin-top: 80px;
`;

export const PolicyAlert = styled.p`
  font-size: 1.6rem;
  line-height: 2rem;
  color: #001758;
  font-family: lato, sans-serif;
  font-weight: 400;
  margin-top: 1rem;
`;

export const Title = styled.div`
  font-size: 2.5rem;
  line-height: 3.1rem;
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

export const Divider = styled.hr`
  width: 75%;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
`;

export const SubmissionContainer = styled.div`
  display: ${(props) => (props.display ? 'block' : 'none')};
`;

export const PolicyButton = styled.button`
  background-color: #44b1df;
  width: 8.5rem;
  border: 0 #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.5rem 2.5rem;
  transition: 0.2s;
  margin-top: 5px;

  &:hover {
    background-color: #545454;
  }
`;

export const FakeForm = styled.div`
  margin: 30px auto;
`;

export const FormText = styled.p`
  margin: 20px;
`;

export const FakeFormInput = styled.input`
  // width: 70%;
  padding: 6px 10px;
  border: 1px solid grey;
  border-radius: 5px;
  margin: 10px;
  font-size: 12px;
`;

PolicyButton.displayName = 'PolicyButton';
